import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWirelessinline = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("path", {
		id: "a",
		d: "M11.971 0L24 7 11.971 19.941 0 8z"
	}) }), /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("mask", {
				id: "b",
				fill: "#fff",
				children: /* @__PURE__ */ _jsx("use", { xlinkHref: "#a" })
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 12,
				cy: 19,
				r: 7,
				stroke: "#000",
				strokeLinecap: "square",
				strokeLinejoin: "round",
				strokeWidth: 1.98,
				mask: "url(#b)"
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 12,
				cy: 18,
				r: 12,
				stroke: "#000",
				strokeLinecap: "square",
				strokeLinejoin: "round",
				strokeWidth: 1.98,
				mask: "url(#b)"
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 12,
				cy: 20,
				r: 3,
				fill: "#000",
				mask: "url(#b)"
			})
		]
	})]
});
export default SvgWirelessinline;
